



























































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";

// Mixins
import BillingCyclesStore from "@/mixins/constants/billingCyclesStore";
import { IProductPrice } from "@/models/products";

@Component
export default class SelectBillingCycle extends Mixins(BillingCyclesStore) {
  public $refs!: {
    billingCycleDropDown: HTMLFormElement;
    customClicked: HTMLFormElement;
  };

  @Prop({ required: true })
  public usedTermsIds!: IProductPrice["billing_cycle_months"][];

  @Prop({ default: 0 })
  public usedTermId!: IProductPrice["billing_cycle_months"];

  @Prop({ default: false })
  public canDelete!: boolean;

  @Prop({ default: "" })
  public iconType!: string;

  @Prop({ default: false })
  public useYearsOnly!: boolean;

  public isLoading = true;

  public selectedTerm = 0;
  public customValue = 1;
  public termActive = false;
  public customClicked = false;

  public get availableTerms() {
    return this.$_.filter(this.billingCycles, billingCycle => {
      return (
        billingCycle.months !== 0 &&
        (this.useYearsOnly ? billingCycle.months % 12 === 0 : true)
      );
    });
  }

  public changeTermActive(newActive) {
    this.termActive = newActive;
  }

  public isTermDisabled(term) {
    return this.usedTermsIds.includes(term);
  }

  public get customValueIsDisabled() {
    return (
      this.usedTermsIds.includes(this.customValue) || this.customValue === 0
    );
  }

  public addTerm(newTerm) {
    this.$emit("newTerm", newTerm);
    this.$refs["billingCycleDropDown"].toggle();
  }

  public get availableCustomValue() {
    return this.findAvailableValue(1, this.usedTermsIds);
  }

  public findAvailableValue(value, usedTerms) {
    if (usedTerms.includes(value)) {
      return this.findAvailableValue(value + 1, this.usedTermsIds);
    }

    return value;
  }

  public deleteTerm() {
    this.$emit("deleteTerm");
  }

  @Watch("termActive", { immediate: true })
  public onTermActive() {
    this.customValue = this.usedTermId
      ? this.usedTermId
      : this.availableCustomValue;
    this.customClicked = false;
  }

  @Watch("billingCyclesLoaded", { immediate: true })
  public onBillingCyclesLoaded() {
    if (!this.billingCyclesLoaded) {
      this.selectedTerm = this.usedTermId;
      this.isLoading = false;
    }
  }

  @Watch("customValue")
  public onCustomValueChange() {
    this.selectedTerm = this.customValue;
  }

  @Watch("customClicked", { immediate: true })
  public onCustomClickedChanged() {
    if (this.customClicked) {
      this.$nextTick(() => {
        this.$refs.customClicked.focus();
      });
    }
  }
}
